import React from 'react';
import Grow from '@material-ui/core/Grow';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { withStyles } from '@material-ui/core/styles';

const defaultSearchStyles = {
  main: {
    display: 'flex',
    flex: '1 0 auto',
    float: 'left'
  },
  searchIcon: {
    marginTop: '10px',
    marginRight: '8px'
  },
  searchText: {
    flex: '0.8 0',
    width: 200
  },
  clearIcon: {
    '&:hover': {
      color: '#FF0000',
    },
  },
};

class TableSearch extends React.Component {

  state = { show: false };

  handleTextChange = event => {
    this.props.onSearch(event.target.value);
  };

  changeVisibility = () => {
    const { toggleTitle } = this.props;
    if (this.state.show) {
      this.setState({ show: false });
      this.props.onSearch('');
      toggleTitle(true);
    }
    else {
      this.setState({ show: true });
      toggleTitle(false);
    }
  }
  
  handleKeyPress = event => {
    if (event.key === 'Enter') {
      event.target.blur();
    }
  }
  
  render() {
    const { classes } = this.props;
    if (this.state.show) {
      return (
        <Grow appear in={true} timeout={300}>
          <div className={classes.main} ref={el => (this.rootRef = el)}>
            <SearchIcon className={classes.searchIcon} />
            <TextField
              className={classes.searchText}
              autoFocus={true}
              InputProps={{
                'aria-label': 'Zoeken',
              }}
              onChange={this.handleTextChange}
              onKeyPress={this.handleKeyPress}
              fullWidth={true}
              inputRef={el => (this.searchField = el)}
            />
            <IconButton className={classes.clearIcon} onClick={this.changeVisibility}>
              <ClearIcon />
            </IconButton>
          </div>
        </Grow>
      );
    }
    else {
      return (<Grow appear in={true} timeout={300}>
        <IconButton className={classes.button} aria-label="Search" onClick={this.changeVisibility}>
          <SearchIcon />
        </IconButton>
      </Grow>);
    }
  }
}

export default withStyles(defaultSearchStyles)(TableSearch);